import { render, staticRenderFns } from "./highlight_content.vue?vue&type=template&id=32a81926&scoped=true&"
import script from "./highlight_content.vue?vue&type=script&lang=js&"
export * from "./highlight_content.vue?vue&type=script&lang=js&"
import style0 from "./highlight_content.vue?vue&type=style&index=0&id=32a81926&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a81926",
  null
  
)

export default component.exports